import { useTranslation } from "react-i18next";
import Card from "../../components/Card/Card";
import { CardContent, CardHeader, CardTitle, CardV2 } from "../../components/CardV2/CardV2";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import Subtitle from "../../components/Subtitle/Subtitle";
import PageWrapper from "../PageWrapper/PageWrapper";
import { useState, Fragment } from "react";
import Pill from "../../components/Pill/Pill";
import { Modal } from "../../components/Modal/Modal";
import FAQ from "../../components/FAQ/FAQ";
import CONFIG from "../../config/config";
import { datadogRum } from "@datadog/browser-rum";

type Currency = 'EUR' | 'USD' | 'PLN';

type Pricing = {
  [K in Currency]: number;
};

type Offer = {
  id: string;
  title: string;
  pricing: Pricing;
  period?: string; // "month", "one-time", etc.
  description: string;
  features: string[];
  imageUrl: string;
  paymentLink?: string;
  howItWorksStepCount?: number;
};

const offers: Offer[] = [
  {
    id: "basic-maintenance",
    title: "benefits_page.offers.basic_maintenance.title",
    pricing: {
      EUR: 29.99,
      USD: 29.99,
      PLN: 99.99
    },
    period: 'month',
    description: "benefits_page.offers.basic_maintenance.description",
    features: [
      "benefits_page.offers.basic_maintenance.features.feature_1",
      "benefits_page.offers.basic_maintenance.features.feature_2",
      "benefits_page.offers.basic_maintenance.features.feature_3",
      "benefits_page.offers.basic_maintenance.features.feature_4",
      "benefits_page.offers.basic_maintenance.features.feature_5",
      "benefits_page.offers.basic_maintenance.features.feature_6"
    ],
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    paymentLink: "https://buy.stripe.com/7sY4gzcmw8tNcQQ3at3F60g"
  },
  {
    id: "basic-website",
    title: "benefits_page.offers.basic_website.title",
    pricing: {
      EUR: 299.99,
      USD: 299.99,
      PLN: 999.99
    },
    period: 'one-time',
    description: "benefits_page.offers.basic_website.description",
    features: [
      "benefits_page.offers.basic_website.features.feature_1",
      "benefits_page.offers.basic_website.features.feature_2",
      "benefits_page.offers.basic_website.features.feature_3",
      "benefits_page.offers.basic_website.features.feature_4",
      "benefits_page.offers.basic_website.features.feature_5",
      "benefits_page.offers.basic_website.features.feature_6",
      "benefits_page.offers.basic_website.features.feature_7",
      "benefits_page.offers.basic_website.features.feature_8"
    ],
    imageUrl: "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    paymentLink: "https://buy.stripe.com/8x24gz9akeSb4kk5iB3F60h"
  },
  {
    id: "advanced-website",
    title: "benefits_page.offers.advanced_website.title",
    pricing: {
      EUR: 899.99,
      USD: 899.99,
      PLN: 3499.99
    },
    period: 'one-time',
    description: "benefits_page.offers.advanced_website.description",
    features: [
      "benefits_page.offers.advanced_website.features.feature_1",
      "benefits_page.offers.advanced_website.features.feature_2",
      "benefits_page.offers.advanced_website.features.feature_3",
      "benefits_page.offers.advanced_website.features.feature_4",
      "benefits_page.offers.advanced_website.features.feature_5",
      "benefits_page.offers.advanced_website.features.feature_6",
      "benefits_page.offers.advanced_website.features.feature_7",
      "benefits_page.offers.advanced_website.features.feature_8",
      "benefits_page.offers.advanced_website.features.feature_9",
      "benefits_page.offers.advanced_website.features.feature_10"
    ],
    imageUrl: "https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    paymentLink: "https://buy.stripe.com/cNi8wPgCMh0j2cccL33F60i"
  },
  {
    id: "ai_automation",
    title: "benefits_page.offers.ai_automation.title",
    pricing: {
      EUR: 99,
      USD: 99,
      PLN: 399
    },
    period: 'month',
    description: "benefits_page.offers.ai_automation.description",
    features: [
      "benefits_page.offers.ai_automation.features.feature_1",
      "benefits_page.offers.ai_automation.features.feature_2",
      "benefits_page.offers.ai_automation.features.feature_3",
      "benefits_page.offers.ai_automation.features.feature_4",
      "benefits_page.offers.ai_automation.features.feature_5",
      "benefits_page.offers.ai_automation.features.feature_6",
      "benefits_page.offers.ai_automation.features.feature_7",
      "benefits_page.offers.ai_automation.features.feature_8"
    ],
    imageUrl: "https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    paymentLink: "https://buy.stripe.com/bJe4gz4U411l188bGZ3F60q"
  },
  {
    id: "store_catalog_app",
    title: "benefits_page.offers.store_catalog_app.title",
    pricing: {
      EUR: 1499,
      USD: 1499,
      PLN: 6499
    },
    period: 'one-time',
    description: "benefits_page.offers.store_catalog_app.description",
    features: [
      "benefits_page.offers.store_catalog_app.features.feature_1",
      "benefits_page.offers.store_catalog_app.features.feature_2",
      "benefits_page.offers.store_catalog_app.features.feature_3",
      "benefits_page.offers.store_catalog_app.features.feature_4",
      "benefits_page.offers.store_catalog_app.features.feature_5",
      "benefits_page.offers.store_catalog_app.features.feature_6",
      "benefits_page.offers.store_catalog_app.features.feature_7",
      "benefits_page.offers.store_catalog_app.features.feature_8"
    ],
    imageUrl: "https://images.unsplash.com/photo-1545235617-7a424c1a60cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    paymentLink: "https://buy.stripe.com/28E9ATgCM11lbMMeTb3F60o"
  },
  {
    id: "social_content_pack",
    title: "benefits_page.offers.social_content_pack.title",
    pricing: {
      EUR: 49,
      USD: 49,
      PLN: 199
    },
    period: 'month',
    description: "benefits_page.offers.social_content_pack.description",
    features: [
      "benefits_page.offers.social_content_pack.features.feature_1",
      "benefits_page.offers.social_content_pack.features.feature_2",
      "benefits_page.offers.social_content_pack.features.feature_3",
      "benefits_page.offers.social_content_pack.features.feature_4",
      "benefits_page.offers.social_content_pack.features.feature_5",
      "benefits_page.offers.social_content_pack.features.feature_6"
    ],
    imageUrl: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    paymentLink: "https://buy.stripe.com/8x200j2LW9xR5oocL33F60p"
  }
];

const currencySymbols: Record<Currency, string> = {
  'EUR': '€',
  'USD': '$',
  'PLN': 'PLN'
};

const formatPrice = (price: number, currency: Currency, period?: string): string => {
  const symbol = currencySymbols[currency];
  const formattedPrice = price.toFixed(2);

  return `${formattedPrice} ${symbol}`;
};

// Service Information Modal Component
const ServiceInfoModal = ({ isOpen, onClose, selectedOffer }: { 
  isOpen: boolean; 
  onClose: () => void; 
  selectedOffer: Offer | null; 
}) => {
  const { t, i18n } = useTranslation();
  
  // Determine currency based on language
  const getCurrencyFromLanguage = (): Currency => {
    const language = i18n.language;
    if (language.startsWith('pl')) return 'PLN';
    if (language.startsWith('de') || language.startsWith('es') || language.startsWith('it') || language.startsWith('pt') || language.startsWith('uk')) return 'EUR';
    return 'USD';
  };
  
  const defaultCurrency = getCurrencyFromLanguage();

  if (!isOpen || !selectedOffer) return null;

  const handlePurchase = () => {
    if (selectedOffer.paymentLink) {
      window.open(selectedOffer.paymentLink, '_blank');
    }
    onClose();
  };

  const handleRequestQuote = () => {
    const serviceName = t(selectedOffer.title);
    const message = t('benefits_page.modal.request_quote_whatsapp_message', { service: serviceName });
    const whatsappUrl = `${CONFIG.CONTACT_INFO.WHATSAPP}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };

  const stepCount = selectedOffer.howItWorksStepCount ?? 4;
  const CheckIcon = () => (
    <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
    </svg>
  );

  return (
    <Modal
      modalTitle={t(selectedOffer.title)}
      canClose={true}
      onClose={onClose}
    >
      <div className="space-y-6">
        {/* Price card */}
        <div className="rounded-xl bg-gradient-to-br from-gray-50 to-gray-100/80 border border-gray-200/80 p-5">
          <div className="flex flex-wrap items-center gap-3">
            <p className="text-3xl font-bold tracking-tight text-gray-900">
              {formatPrice(selectedOffer.pricing[defaultCurrency], defaultCurrency, selectedOffer.period)}
            </p>
            <Pill 
              text={t(selectedOffer.period === 'month' ? 'benefits_page.pill.subscription' : 'benefits_page.pill.one_time')} 
              color={selectedOffer.period === 'month' ? 'blue' : 'green'}
            />
          </div>
        </div>

        {/* How it works */}
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-500 mb-4">
            {t('benefits_page.modal.how_it_works')}
          </h3>
          <div className="space-y-4">
            {Array.from({ length: stepCount }, (_, i) => i + 1).map((stepNum) => {
              const titleKey = `benefits_page.modal.steps.${selectedOffer.id}.step_${stepNum}.title`;
              const descKey = `benefits_page.modal.steps.${selectedOffer.id}.step_${stepNum}.description`;
              const fallbackTitleKey = `benefits_page.modal.step_${stepNum}.title`;
              const fallbackDescKey = `benefits_page.modal.step_${stepNum}.description`;
              const title = t(titleKey) === titleKey ? t(fallbackTitleKey) : t(titleKey);
              const description = t(descKey) === descKey ? t(fallbackDescKey) : t(descKey);
              return (
                <div key={stepNum} className="flex gap-4">
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-900 text-sm font-semibold text-gray-50">
                    {stepNum}
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{title}</p>
                    <p className="mt-0.5 text-sm leading-relaxed text-gray-600">{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* What's included */}
        <div className="rounded-xl border border-gray-200/80 bg-muted p-4">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-500 mb-3">
            {t('benefits_page.modal.whats_included')}
          </h3>
          <ul className="grid gap-2 sm:grid-cols-2">
            {selectedOffer.features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2.5 text-sm text-gray-700">
                <span className="mt-0.5 text-emerald-600">
                  <CheckIcon />
                </span>
                <span className="leading-snug">{t(feature)}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <div className="flex justify-center pt-2">
          {selectedOffer.paymentLink ? (
            <PrimaryButton
              text={t('benefits_page.modal.purchase_now')!}
              fn={handlePurchase}
              actionName={`Purchase ${t(selectedOffer.title)}`}
            />
          ) : (
            <PrimaryButton
              text={t('benefits_page.modal.request_quote')!}
              fn={handleRequestQuote}
              actionName={`Request quote ${t(selectedOffer.title)}`}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

function BenefitsPage() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);

  const handleGetOffer = (offer: Offer) => {
    datadogRum.addAction('Benefits offer details viewed', {
      offerId: offer.id,
    });
    setSelectedOffer(offer);
    setIsModalOpen(true);
  };

  return (
    <PageWrapper>
      <Fragment>
          <div className="mt-5 space-y-5">
          {/* Introduction Section */}
          <div>
            <Card>
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-muted dark:to-accent p-6 rounded-lg">
                <div className="text-center space-y-4">
                  <Subtitle text={String(t('benefits_page.introduction.title'))} />
                  <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
                    {t('benefits_page.introduction.description')}
                  </p>
                  <div className="flex flex-col sm:flex-row justify-center items-center gap-4 pt-2">
                    <div className="flex items-center text-sm text-gray-500">
                      <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {t('benefits_page.introduction.benefit_1')}
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {t('benefits_page.introduction.benefit_2')}
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {t('benefits_page.introduction.benefit_3')}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {offers.map((offer) => (
              <Card key={offer.id}>
                <div className="flex flex-col h-full">
                  {/* Header Image with Gradient Overlay */}
                  <div className="relative h-48 rounded-lg overflow-hidden mb-4">
                    {/* Background Image */}
                    <div 
                      className="absolute inset-0 bg-cover bg-center z-0"
                      style={{ backgroundImage: `url(${offer.imageUrl})` }}
                    />
                    
                    {/* Gradient Overlay - Multiple approaches */}
                    <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 h-24 z-20 bg-gradient-to-t from-black to-transparent"></div>
                    
                    {/* Content Overlay */}
                    <div className="absolute inset-0 flex flex-col justify-end p-4 z-30">
                      <h3 className="text-xl font-bold text-white mb-1">{t(offer.title)}</h3>
                      <div className="flex items-center gap-2">
                        <Pill 
                          text={t(offer.period === 'month' ? 'benefits_page.pill.subscription' : 'benefits_page.pill.one_time')} 
                          color={offer.period === 'month' ? 'blue' : 'green'}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex flex-col flex-1">
                    <div className="flex-1 space-y-4">
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {t(offer.description)}
                      </p>

                      {/* Features List */}
                      <div className="space-y-2">
                        <h4 className="font-semibold text-gray-900 text-sm">{t('benefits_page.card.whats_included')}</h4>
                        <ul className="space-y-1">
                          {offer.features.map((feature, index) => (
                            <li key={index} className="flex items-center text-sm text-gray-600">
                              <svg 
                                className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" 
                                fill="currentColor" 
                                viewBox="0 0 20 20"
                              >
                                <path 
                                  fillRule="evenodd" 
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
                                  clipRule="evenodd" 
                                />
                              </svg>
                              {t(feature)}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Action Button - Aligned to bottom */}
                    <div className="pt-4 mt-auto flex justify-center">
                      <PrimaryButton
                        text={t('benefits_page.card.get_started')!}
                        fn={() => handleGetOffer(offer)}
                        actionName={`Get ${t(offer.title)}`}
                      />
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* FAQ Section */}
          <div>
            <CardV2>
              <CardHeader>
                <CardTitle className="text-center">{t('global.faq.title')}</CardTitle>
              </CardHeader>
              <CardContent>
                <FAQ 
                  items={[
                    {
                      id: 'existing-website',
                      questionKey: 'benefits_page.faq.existing_website.question',
                      answerKey: 'benefits_page.faq.existing_website.answer'
                    },
                    {
                      id: 'no-idea',
                      questionKey: 'benefits_page.faq.no_idea.question',
                      answerKey: 'benefits_page.faq.no_idea.answer'
                    },
                    {
                      id: 'maintenance',
                      questionKey: 'benefits_page.faq.maintenance.question',
                      answerKey: 'benefits_page.faq.maintenance.answer'
                    },
                    {
                      id: 'learn-maintenance',
                      questionKey: 'benefits_page.faq.learn_maintenance.question',
                      answerKey: 'benefits_page.faq.learn_maintenance.answer'
                    },
                    {
                      id: 'timeline',
                      questionKey: 'benefits_page.faq.timeline.question',
                      answerKey: 'benefits_page.faq.timeline.answer'
                    },
                    {
                      id: 'revisions',
                      questionKey: 'benefits_page.faq.revisions.question',
                      answerKey: 'benefits_page.faq.revisions.answer'
                    },
                    {
                      id: 'integration',
                      questionKey: 'benefits_page.faq.integration.question',
                      answerKey: 'benefits_page.faq.integration.answer'
                    },
                    {
                      id: 'in_store_app',
                      questionKey: 'benefits_page.faq.in_store_app.question',
                      answerKey: 'benefits_page.faq.in_store_app.answer'
                    },
                    {
                      id: 'ai_automation_tools',
                      questionKey: 'benefits_page.faq.ai_automation_tools.question',
                      answerKey: 'benefits_page.faq.ai_automation_tools.answer'
                    }
                  ]}
                />
              </CardContent>
            </CardV2>
          </div>
        </div>

        {/* Service Information Modal */}
        {isModalOpen && selectedOffer && (
          <ServiceInfoModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            selectedOffer={selectedOffer}
          />
        )}
      </Fragment>
    </PageWrapper>
  );
}

export default BenefitsPage; 